/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_And_Register_BtnInputs */



/**
* | output |
* | --- |
* | "Create & Register" |
*
* @param {Create_And_Register_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const create_and_register_btn = /** @type {((inputs?: Create_And_Register_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_And_Register_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créer & Inscrire")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear e Inscribir")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Criar & Inscrever")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea & Iscrivi")
	return /** @type {LocalizedString} */ ("Create & Register")
});